import { Environment, environment_types, WEBSITE_URLS } from "../app/shared/global";
import { version } from '../../package.json'


export const ENV: Environment = {
    app_version: version + "-alpha",
    production: false,
    tracing: true,
    environment_type: environment_types.development,
    sentry_enabled: true,
};

export const ENV_URLS: WEBSITE_URLS = (<any>window)._env;
